<template>
  <!-- 搜索  -->
  <div class="search-component">
    <i class="iconfont icon-sousuo search" @click="submit"></i>
    <input
      type="text"
      class="search"
      v-on:keyup.enter="search"
      v-model="keyword"
      placeholder="地址 / 交易哈希 / 区块高度"
    />
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import axios from "./../mixins/axios";
export default {
  data() {
    return {
      Value: "",
      keyword: "",
      height: 0,
      getLastHeighttime: 0,
    };
  },
  mounted() {
    this.height = sessionStorage.getItem("maxHeight");
  },
  methods: {
    search() {
      try {
        console.log("start search:" + this.keyword);
        var reg = /^[0-9]*[1-9][0-9]*$/;
        if (this.keyword == "") return;
        if (reg.test(this.keyword) || this.keyword == 0) {
          console.log("search block");
          //判断两个高度差---int类型比较
          axios.get("/api/v1/block?id=" + this.keyword).then((data) => {
            if (data.data != null) {
              this.$router.push({
                path: "/blockDetail",
                query: { height: this.keyword.trim() },
              });
              this.keyword = "";
            } else {
              Toast("输入信息有误，请重新输入");
            }
          });
        } else {
          let e = this.keyword.length;
          if (e === 66 || e === 64) {
            console.log("search tx");
            this.keyword =
              e === 64 && !this.keyword.startsWith("0x")
                ? "0x" + this.keyword
                : this.keyword;
            //交易的哈希值---地址64位字节加上16进制标示0x(共66位)
            axios
              .get("/api/v1/tx?id=" + this.keyword)
              .then((data) => {
                // console.log("res=", data);
                if (data.data != null) {
                  this.$router.push({
                    path: "/tradeHash",
                    query: { hash: this.keyword },
                  });
                  this.keyword = "";
                } else {
                  Toast("输入信息有误，请重新输入");
                }
              })
              .catch((err) => {
                console.log("err", err);
                this.showErrorPage();
              });
          } else if (e === 40 || e === 42) {
            console.log("search addr");
            //地址
            axios
              .get("/api/v1/transaction/balance?miner=" + this.keyword)
              .then((data) => {
                if (data.data != null) {
                  this.$router.push({
                    path: "/addressDetail",
                    query: { address: this.keyword, way: 0 },
                  });
                  this.keyword = "";
                } else {
                  this.showErrorPage();
                }
              });
          } else {
            console.log("search other");
            Toast("输入信息有误，请重新输入");
          }
        }
      } catch (e) {
        Toast("输入信息有误，请重新输入");
      }
    },
    submit() {
      this.height = sessionStorage.getItem("maxHeight");
      var reg = /^[0-9]*[1-9][0-9]*$/;
      if (this.Value.trim() == "")
        return Toast("请输入交易哈希/区块哈希/地址/区块高度");
      if (reg.test(this.Value.trim()) || this.Value == 0) {
        if (Number(this.Value.trim()) <= Number(this.height)) {
          //判断两个高度差---int类型比较
          this.$chain33Rpc.getBlockHash(Number(this.Value)).then((data) => {
            if (data.error == null) {
              this.$router.push({
                path: "/blockDetail",
                query: { height: this.Value.trim() },
              });
              this.Value = "";
            } else {
              Toast("输入信息有误，请重新输入");
              this.Value = "";
            }
          });
        } else {
          Toast("输入的高度不能超过最大高度!");
          this.Value = "";
        }
      } else {
        let e = this.Value.length;
        if (e === 66 || e === 64) {
          this.Value = e === 64 ? "0x" + this.Value : this.Value;
          //交易的哈希值---地址64位字节加上16进制标示0x(共66位)
          this.$chain33Rpc.queryTransaction(this.Value).then((data) => {
            if (data.error == null) {
              this.$router.push({
                path: "/tradeHash",
                query: { hash: this.Value },
              });
              this.Value = "";
            } else {
              //区块哈希
              this.$chain33Rpc.getBlockOverview(this.Value).then((data) => {
                if (data.error == null) {
                  this.$router.push({
                    path: "/blockDetail",
                    query: { height: data.result.head.height },
                  });
                  this.Value = "";
                } else {
                  Toast("输入信息有误，请重新输入");
                  this.Value = "";
                }
              });
            }
          });
        } else {
          //地址
          this.$chain33Rpc.getAddrOverview(this.Value).then((data) => {
            if (data.error == null) {
              this.$router.push({
                path: "/addressDetail",
                query: { address: this.Value, way: 0 },
              });
              this.Value = "";
            } else {
              Toast("输入信息有误，请重新输入");
              this.Value = "";
            }
          });
        }
      }
    },
  },
};
</script>